import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import { FAQS, CONTACT } from "../data";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { SpeakButton } from "../components/SpeakButton";
import { CTABand } from "../components/CTABand";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "../components/ui/accordion";

export default function FAQ() {
  return (
    <div data-testid="faq-page">
      <PageHero
        eyebrow="Questions & Answers"
        title="Frequently asked questions"
        subtitle="Not sure about something? Here are answers to the questions we hear most. Still curious? Just give us a call."
      />

      <section className="max-w-3xl mx-auto px-5 sm:px-8 py-20 lg:py-24">
        <Reveal>
          <Accordion type="single" collapsible className="space-y-4">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={f.q}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="rounded-2xl border border-border bg-card px-6"
              >
                <AccordionTrigger className="text-left font-heading font-bold text-lg text-foreground hover:no-underline py-6">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-lg leading-relaxed pb-6">
                  {f.a}
                  <div className="mt-4">
                    <SpeakButton
                      text={`${f.q}. ${f.a}`}
                      testId={`faq-speak-${i}`}
                    />
                  </div>
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="mt-12 rounded-2xl bg-secondary border border-border p-8 text-center">
            <h3 className="font-heading font-bold text-2xl text-foreground">Still have a question?</h3>
            <p className="mt-2 text-muted-foreground text-lg">We're happy to talk it through — no pressure at all.</p>
            <div className="mt-6 flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href={CONTACT.phoneHref}
                data-testid="faq-call-now"
                className="inline-flex items-center justify-center gap-2 h-14 px-8 rounded-full bg-accent text-white font-bold text-lg hover:bg-[hsl(196,82%,27%)] transition-colors"
              >
                <Phone className="h-5 w-5" /> Call {CONTACT.phone}
              </a>
              <Link
                to="/contact"
                data-testid="faq-contact"
                className="inline-flex items-center justify-center h-14 px-8 rounded-full bg-primary text-white font-bold text-lg hover:bg-slate-800 transition-colors"
              >
                Send us a Message
              </Link>
            </div>
          </div>
        </Reveal>
      </section>

      <CTABand />
    </div>
  );
}
